<script setup>
	import BaseIcon from "@/components/BaseIcon.vue";
	import iconClassNames from "@/components/iconClassNames";
	import { ref, onMounted } from "vue";

	const base = ref(null);
	const props = defineProps({ fontSize: String });

	onMounted(() => {
		base.value.className = iconClassNames.classes;
		base.value.fontSize = props.fontSize;
	});
</script>

<template>
	<BaseIcon ref="base"/>
</template>
